import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import IgreenVideo from '../assets/video/igreen.mp4';
import '../styler.css';
import img1 from '../assets/Images/1-3.png';
import img2 from '../assets/Images/1-4.png';
import img3 from '../assets/Images/1-5.png';

const PlacasLead = () => {
    const handleWhatsAppClick = () => {
        window.open('https://wa.me/+5521999462091', '_blank');
    };

    return (
        <div className="home-container">
            <header className="header">
                <h1>Você sabia que o Brasil tem um dos maiores potenciais solares do mundo? Aproveitar essa energia limpa e inesgotável pode transformar a sua vida!</h1>
                <video className="intro-video" controls>
                    <source src={IgreenVideo} type="video/mp4" />
                    Seu navegador não suporta o elemento de vídeo.
                </video>
            </header>
            <section className="photos-section">
                <h2>com Igreen Club faça a diferença hoje mesmo.</h2>
                <div className="photos-grid">
                    <img src={img1} alt="Placas Solares" />
                    <img src={img2} alt="Igreen Club" />
                    <img src={img3} alt="Desconto" />
                    {/* Adicione mais imagens conforme necessário */}
                </div>
            </section>
            <section className="contact-section">
                <h2>Entre em Contato</h2>
                <button className="whatsapp-button" onClick={handleWhatsAppClick}>
                    <FontAwesomeIcon icon={faWhatsapp} /> Fale Conosco via WhatsApp
                </button>
            </section>
        </div>
    );
};

export default PlacasLead;
